import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { SidePanelLoginFailure } from '@auth-app/shared-ui';
import { App } from './app';
var container = document.getElementById('app');
if (!container) throw new Error('Failed to find the root element');
var root = createRoot(container);
root.render(/*#__PURE__*/ _jsx(App, {
    children: /*#__PURE__*/ _jsx(SidePanelLoginFailure, {})
}));
